// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import LiveFormValidation from './forms';
import './naja';
import './ui';

window.LiveForm = LiveFormValidation.LiveForm;
window.Nette = LiveFormValidation.Nette;
